import React from 'react';
import { connect } from 'dva';
import { injectIntl, FormattedMessage } from 'react-intl';
import { Row, Col, Table, Tooltip, Button, Icon, Spin, Modal, Popover, Card } from 'antd';
import { Link } from 'dva/router';
import Sticky from 'react-sticky-el';
import { AjaxTable, SearchComponent } from '../../../components';
import { CopyIcon, PencilIcon, TrashIcon } from '../../Icons';
import { userRoleInCurrentProject } from '../../../selectors/app';
import Roles from '../../../utils/roles';
import {
  ACTION_APP_ADD_NOTIFICATION,
  ACTION_APP_GO_TO_ROUTE,
  ACTION_APP_SHOW_NOTIFICATION,
} from '../../../models/app';
import {
  ACTION_AI_OUTREACH_AGENTS_LOADLIST,
  ACTION_AI_OUTREACH_AGENTS_REMOVE,
} from '../../../models/aiOutreachAgents';
import { ROUTE_AI_OUTREACH_AGENTS_NEW } from '../../../routes';
import styles from './../styles.less';
import MultiplyItemsColumnRender from '../../common/Table/MultiplyItemsColumnRender';

const { Column } = Table;
const createBtnAvailableRoles = [
  Roles.role_super_admin.id,
  Roles.role_admin.id,
];

class AIOutreachAgentsList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: {
        search: undefined,
      },
      removedId: null,
      visibleBudgetInfo: false,
      budget: null,
    };

    this.projectId = this.props.currentProjectId || this.props.match.params.projectId;
  }

  componentDidMount() {
    this.props.dispatch({
      type: 'header/update',
      payload: {
        title: 'Component.AIOutreachAgents.List.Title',
        description: 'Component.AIOutreachAgents.List.Description',
      },
    });

    this.showNotifications();
  }

  getData = (psf) => {
    const projectId = this.projectId;
    const filter = { name: this.state.filter.search };
    const payload = { projectId, filter, ...psf };

    if (Object.keys(this.state.filter).length > 0) {
      payload.filtered = true;
    }

    return this.props.dispatch({ type: ACTION_AI_OUTREACH_AGENTS_LOADLIST, payload });
  };

  // eslint-disable-next-line react/sort-comp
  addNotification() {
    this.props.dispatch({
      type: ACTION_APP_ADD_NOTIFICATION,
      payload: {
        type: 'success',
        message: 'Common.Success',
        description: 'Component.AIOutreachAgents.Remove.Success.Text',
      },
    });
  }

  showNotifications() {
    this.props.dispatch({ type: ACTION_APP_SHOW_NOTIFICATION });
  }

  goToAIOutreachAgentsNew = () => {
    const projectId = this.projectId;
    this.props.dispatch({
      type: ACTION_APP_GO_TO_ROUTE,
      payload: { routeName: ROUTE_AI_OUTREACH_AGENTS_NEW, projectId },
    });
  };

  removeItemModal = item => () => {
    return Modal.confirm({
      title: this.props.intl.formatMessage({ id: 'Common.Attention' }),
      content: this.props.intl.formatMessage(
        { id: 'Component.AIOutreachAgents.Modal.Description' },
        { aiOutreachAgentName: item.name },
      ),
      okText: this.props.intl.formatMessage({ id: 'Common.Remove' }),
      cancelText: this.props.intl.formatMessage({ id: 'Common.Cancel' }),
      okType: 'danger',
      onOk: () => {
        this.removeItem(item.id);
      },
    });
  };

  removeItem = (id) => {
    this.props
      .dispatch({ type: ACTION_AI_OUTREACH_AGENTS_REMOVE, payload: { id } })
      .then((response) => {
        if (response.success) {
          this.addNotification();
          this.showNotifications();
          this.setState({ removedId: id });
        }
      });
  };

  handleVisibleChange = (visible) => {
    if (visible && !this.state.budget) {
      this.props
        .dispatch({ type: 'leadContact/getBudget' })
        .then((response) => {
          const data = response.body;
          const budget = {
            contact_searches_calls_budget: data.contact_searches_calls_budget,
            contact_enrichment_calls_budget: data.contact_enrichment_calls_budget,
            usage_search: data.usage_search || {},
            usage_enrichment: data.usage_enrichment || {},
          };

          const keys = new Set([...Object.keys(budget.usage_search), ...Object.keys(budget.usage_enrichment)]);

          this.setState({ budget: {
            ...budget,
            displayData: Array.from(keys).sort().reverse().map(key => ({
              date: key,
              search: budget.usage_search[key] && budget.usage_search[key].count ? budget.usage_search[key].count : 0,
              enrichment: budget.usage_enrichment[key] && budget.usage_enrichment[key].count ? budget.usage_enrichment[key].count : 0,
            })),
          } });
        });
    }
    this.setState({ visibleBudgetInfo: visible });
  };

  getBudgetContent = () => {
    const { budget } = this.state;
    const searchBudget = budget ? budget.contact_searches_calls_budget : 0;
    const enrichmentBudget = budget ? budget.contact_enrichment_calls_budget : 0;

    const currentDate = new Date().toISOString().slice(0, 7);
    const currentSearchUsage = budget && budget.usage_search[currentDate] ? budget.usage_search[currentDate].count : 0;
    const currentEnrichmentUsage = budget && budget.usage_enrichment[currentDate] ? budget.usage_enrichment[currentDate].count : 0;

    return (<Card className={styles.budgetWrapperCard} loading={!budget}>
      <Card className={styles.budgetAllowedCard}>
        <h5>
          <FormattedMessage id="Component.AIOutreachAgents.Budget.CurrentMonthBudget" />
        </h5>

        <Row>
          <Col span={10}>
            <FormattedMessage id="Component.AIOutreachAgents.Budget.Type" />
          </Col>
          <Col span={8}>
            <FormattedMessage id="Component.AIOutreachAgents.List.Budget" />
          </Col>
          <Col span={6}>
            <FormattedMessage id="Component.AIOutreachAgents.List.BudgetLeft" />
          </Col>
        </Row>
        <Row>
          <Col span={10}>
            <FormattedMessage id="Component.AIOutreachAgents.Budget.Search" />
          </Col>
          <Col span={8}>{searchBudget}</Col>
          <Col span={6}>{searchBudget - currentSearchUsage}</Col>
        </Row>
        <Row>
          <Col span={10}>
            <FormattedMessage id="Component.AIOutreachAgents.Budget.Enrichment" />
          </Col>
          <Col span={8}>{enrichmentBudget}</Col>
          <Col span={6}>{enrichmentBudget - currentEnrichmentUsage}</Col>
        </Row>
      </Card>
      <Card className={styles.budgetAllowedCard}>
        <h5>
          <FormattedMessage id="Component.AIOutreachAgents.Budget.Usage" />
        </h5>

        {budget && budget.displayData.length > 0 ? <React.Fragment>
          <Row>
            <Col span={8}>
              <FormattedMessage id="Component.AIOutreachAgents.Budget.Date" />
            </Col>
            <Col span={8}>
              <FormattedMessage id="Component.AIOutreachAgents.Budget.Search" />
            </Col>
            <Col span={8}>
              <FormattedMessage id="Component.AIOutreachAgents.Budget.Enrichment" />
            </Col>
          </Row>
          {budget.displayData.map(item => (
            <Row key={item.date}>
              <Col span={8}>
                { item.date }
              </Col>
              <Col span={8}>
                { item.search }
              </Col>
              <Col span={8}>
                { item.enrichment }
              </Col>
            </Row>
          ))}
        </React.Fragment> : <Row type="flex" justify="center">
          <Col>
            <FormattedMessage id="Common.NoData" />
          </Col>
        </Row>}
      </Card>
    </Card>);
  }

  render() {
    const { projectId, filter, removedId, visibleBudgetInfo } = this.state;
    const { loading, userRole } = this.props;

    return (
      <div className={styles.containerLarge}>
        <Sticky
          className="sticky-bar"
          scrollElement=".ant-layout"
          stickyClassName="_sticky"
        >
          <div className="sticky-wrapper">
            <Row gutter={6}>
              <SearchComponent
                self={this}
                fieldPlaceholder={this.props.intl.formatMessage({
                  id: 'Component.AIOutreachAgents.List.SearchByNamePlaceholder',
                })}
              />
              <Col span={5}>
                <Popover
                  content={this.getBudgetContent()}
                  trigger="click"
                  visible={visibleBudgetInfo}
                  onVisibleChange={this.handleVisibleChange}
                  placement="bottom"
                >
                  <Button type="primary" className={styles.viewBudget}>
                    <FormattedMessage id="Component.AIOutreachAgents.List.ViewBudget" />
                  </Button>
                </Popover>
              </Col>
              <Col span={9} className="text-right">
                {createBtnAvailableRoles.includes(userRole) && (
                  <Button
                    size="large"
                    type="primary"
                    onClick={this.goToAIOutreachAgentsNew}
                  >
                    <Icon type="plus" />
                    <FormattedMessage id="Component.AIOutreachAgents.List.Create" />
                  </Button>
                )}
              </Col>
            </Row>
          </div>
        </Sticky>
        <Spin spinning={loading.models.aiOutreachAgents}>
          <AjaxTable
            getData={this.getData}
            rowKey="id"
            updateKey={JSON.stringify([filter, projectId, removedId])}
          >
            <Column
              dataIndex="name"
              title={this.props.intl.formatMessage({ id: 'Grid.Column.Name' })}
              sorter
              render={data => <div>{data}</div>}
            />
            <Column
              title={this.props.intl.formatMessage({ id: 'Grid.Column.Url.Labels' })}
              key="url_fields"
              dataIndex="url_fields"
              render={url_fields => (
                <div
                  className={styles.row}
                  data-label={this.props.intl.formatMessage({ id: 'Grid.Column.Url.Labels' })}
                >
                  {url_fields.length ?
                    <div className="cell-popover">
                      <MultiplyItemsColumnRender itemList={url_fields} />
                    </div>
                    : <FormattedMessage id="Common.NoData" />
                  }
                </div>
              )}
            />
            <Column
              title={this.props.intl.formatMessage({
                id: 'Grid.Column.Actions',
              })}
              key="actions"
              className="text-center"
              width={150}
              fixed="right"
              render={item => (
                <div className="actions" data-label={item.id}>
                  <Tooltip
                    className="hint action-wrap"
                    placement="top"
                    title={this.props.intl.formatMessage({
                      id: 'Grid.Column.Edit',
                    })}
                  >
                    <Link to={`./${item.id}/edit/`}>
                      <PencilIcon />
                    </Link>
                  </Tooltip>
                  <Tooltip
                    className="hint action-wrap"
                    placement="top"
                    title={this.props.intl.formatMessage({
                      id: 'Grid.Column.Copy',
                    })}
                  >
                    <Link to={`./new/${item.id}`}>
                      <CopyIcon />
                    </Link>
                  </Tooltip>
                  <Tooltip
                    className="hint action-wrap"
                    placement="top"
                    title={this.props.intl.formatMessage({
                      id: 'Grid.Column.Delete',
                    })}
                  >
                    <button onClick={this.removeItemModal(item)}>
                      <TrashIcon />
                    </button>
                  </Tooltip>
                </div>
              )}
            />
          </AjaxTable>
        </Spin>
      </div>
    );
  }
}

export default connect(({ app, loading }) => ({
  currentProjectId: app.currentProjectId,
  loading,
  userRole: userRoleInCurrentProject(app),
}))(injectIntl(AIOutreachAgentsList));



// WEBPACK FOOTER //
// ./src/components/AIOutreachAgents/AIOutreachAgentsList/index.js